import type { RecipientCustomType as ApiRecipientCustomType } from 'src/api/generated/touring/types';
import type { RecipientCustomType } from '../../types';

export const mapRecipientCustomType = (
  api: ApiRecipientCustomType
): RecipientCustomType => ({
  id: api.id,
  emailField: api.emailField,
  name: api.name,
  email: api.email,
});
